<mat-sidenav-container class="imei-info-sidenav-container" style="height: 100%;">
  <mat-sidenav #imeisidenav position="end" mode="over" [(opened)]="opened" (opened)="events.push('open!')"
              (closed)="events.push('close!')">
              <pgh-imei-info (closeEvent)="closeSideNav()" [imeiInfoDeviceType]="imeiInfoDeviceType"></pgh-imei-info>
  </mat-sidenav>

  <mat-sidenav-content>

<div id="body-container" style="height: 100%;">

  <ng-container>
    <!--<div class="back container pt-4" *ngIf="isBackVisible">
      <button class="link" (click)="gotoBack()" style="padding-left:0px;"><mat-icon
          style="padding-top:6px;">keyboard_arrow_left</mat-icon>
          <adp-label labelKey="Global_Button_Back"></adp-label></button>
    </div>-->

    <div class="back container pt-4" style="display:flex;" *ngIf="state != states.LandingPage && state != states.AdditionalDeviceQuestionnaire">
      <div *ngIf="isBackVisible" style="white-space: nowrap;">
        <button class="link" (click)="gotoBack()" style="padding-left:0px;"><mat-icon
          style="padding-top:6px;">keyboard_arrow_left</mat-icon><adp-label labelKey="Global_Button_Back"></adp-label></button>
      </div>
      <div style="width:100%;"></div>
      <div style="white-space: nowrap;">
        <button class="link" (click)="goToDashboard()" style="padding-left:0px;padding-top:8px;"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
      </div>
    </div>



    <pgh-landing-page *ngIf="state === states.LandingPage" [isOnboardingFlow]="true" (nextEvent)="changeState(states.NextSteps)"></pgh-landing-page>

    <div [ngClass]="state != states.LandingPage?'phone-registration-page':''">
      <pgh-next-steps *ngIf="state === states.NextSteps" [isOnboardingFlow]="true" (nextEvent)="changeState(states.ConfirmNumber)"
        (backEvent)="changeState(states.LandingPage)" [nextStepsInfoDeviceTypeTemplate]="nextStepsInfoDeviceTypeTemplate"></pgh-next-steps>

      <pgh-confirm-number *ngIf="state === states.ConfirmNumber" (nextEvent)="goToImeiLookup({'data': $event,'state' : states.ImeiInfo})"></pgh-confirm-number>

      <pgh-imei-lookup *ngIf="state === states.ImeiInfo" [isOnboardingFlow]="true" [onboardingFlowDevice]="device"
        [imeiLookupDeviceTypeTemplate]="imeiLookupDeviceTypeTemplate"
        (viewIMEIInfo)="sidenav.toggle()"
        (nextEvent)="handleImeiLookupCompleted($event)"></pgh-imei-lookup>

      <pgh-cellular-device-info-form class="step-item" *ngIf="state === states.ProvideAdditionalInfo"
      preHeaderTextSfKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"
      headerTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Header_Text"
      bodyTextSfKey="RegisterCellularDevice_AdditionalInformationStep_Body_Text"
      submitButtonLabelSfKey="Global_Button_Next"
      [devicesFromAllInventories]="devicesFromAllInventories"
      [serialSearchResponse]="imeiStepResult.imeiLookupResult"
      (formSubmitted)="handleDeviceInfoFormSubmitted($event)"
      ></pgh-cellular-device-info-form>

      <pgh-text-message *ngIf="state === states.TextMessage" [isOnboardingFlow]="true" [phoneNumber]="phoneNumber" (nextEvent)="goToAdditionalDeviceQuestionnaire({'data':$event,'state':states.AdditionalDeviceQuestionnaire})"></pgh-text-message>
      <pgh-additional-device-questionnaire *ngIf="state === states.AdditionalDeviceQuestionnaire" (nextEvent)="goToAdditionalDeviceSelection({'data':$event,'state':states.AdditionalDeviceSelection})"></pgh-additional-device-questionnaire>
      <!--<pgh-additional-device-selection *ngIf="state === states.AdditionalDeviceSelection" (backEvent)="changeState(states.AdditionalDeviceQuestionnaire)" (nextEvent)="goToAdditionalDeviceRegistration({'data':$event})"></pgh-additional-device-selection>-->
    </div>
  </ng-container>
</div>

</mat-sidenav-content>
</mat-sidenav-container>
